import { ChangeEvent, FC, useRef } from 'react';
import { Icon } from 'common-components';
import classNames from 'classnames';
import styles from './uploadImage.module.scss';

const UploadImage: FC<UploadImageProps> = (props: UploadImageProps) => {
    const { onDelete, onUpload, showDelete = false } = props;

    const fileInputRef = useRef<HTMLInputElement>(null);

    const onUploadAction = () => {
        fileInputRef?.current?.click();
    };

    return (
        <div className={styles.container}>
            <div className={styles['camera-container']}>
                <Icon name={'cameraPurple'} className={styles.camera} />
                <div className={classNames(styles.plus, showDelete ? styles['align-left'] : styles['align-center'])}>
                    <Icon name={'plusButton'} onClick={onUploadAction} />
                </div>
                {showDelete && (
                    <div className={styles.trash}>
                        <Icon name={'trashButton'} onClick={onDelete} />
                    </div>
                )}
            </div>
            <input
                id="upload-file"
                accept={'image/*'}
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={onUpload}
            />
        </div>
    );
};

interface UploadImageProps {
    onUpload: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
    onDelete: () => void;
    showDelete?: boolean;
}

export default UploadImage;
